// Possible values higherEnvironment, localEnvironment
export const CURRENT_ENVIROMENT = {
  environment: 'higherEnvironment'
};
